var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38454 4.98682L3.20724 4.98682L3.20724 10.4782L1.38454 10.4782C1.28255 10.4782 1.18474 10.4324 1.11263 10.3507C1.04051 10.2691 1 10.1584 1 10.0431L1 5.42195C1 5.30655 1.04051 5.19587 1.11263 5.11426C1.18474 5.03267 1.28255 4.98682 1.38454 4.98682Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20722 4.98645L5.16065 1.45316C5.23636 1.31352 5.34274 1.19843 5.46943 1.11912C5.59612 1.03981 5.73881 0.998997 5.88358 1.00063C5.99761 0.99597 6.1113 1.01722 6.21793 1.06314C6.32458 1.10905 6.42199 1.17868 6.50445 1.26793C6.5869 1.35717 6.65271 1.46421 6.69797 1.58273C6.74324 1.70124 6.76706 1.82881 6.76801 1.95792L6.76801 4.49039L10.1442 4.49039C10.269 4.49497 10.3915 4.52937 10.5036 4.59136C10.6158 4.65333 10.7151 4.74146 10.795 4.84997C10.8749 4.95848 10.9336 5.08489 10.9673 5.22091C11.0009 5.35693 11.0087 5.49946 10.9902 5.63914L10.3749 10.1297C10.3487 10.3697 10.2459 10.5906 10.0859 10.7509C9.92588 10.9111 9.7196 10.9997 9.50588 11L4.4608 11C4.22064 11.001 3.98359 10.9385 3.76864 10.8172L3.21491 10.5039",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20721 4.98657L3.20722 10.478",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveActive);
export default __webpack_public_path__ + "static/media/positive-active.d297ef1dbc136fc8a9dcb9d69ecd83d8.svg";
export { ForwardRef as ReactComponent };